import { useState } from 'react';
import { LayoutModule } from '../../../layout/modules';
import { Submotive2Filters } from './filters';
import { Submotive2List } from './list';
import { SUBMOTIVE2, SUBMOTIVE2_NEW } from '../../../../routes/paths';
import ActionButtonGroup from '../../../components/general/buttons/actionButtonGroup';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { isOnlyViewProfile } from '../../../../shared/types/profiles';
import { Param } from '../../../../shared/types/param';

export const Submotive2 = () => {
    const [filters, setFilters] = useState<Param>();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    return (
        <>
            <LayoutModule
                title="Búsqueda de submotivo 2"
                showTitle
                additionalButtons={
                    <ActionButtonGroup
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: SUBMOTIVE2_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: SUBMOTIVE2,
                        }}
                    />
                }
            >
                <Submotive2Filters
                    onFilter={(filters) => setFilters(filters)}
                />
            </LayoutModule>
            <Submotive2List filters={filters} />
        </>
    );
};
